import { API_DOMAIN, API_DOMAIN_LOCAL, API_ENDPOINT_BASE_DOKAN } from '../ApiEnv';

export const reportsAPI = `${API_DOMAIN}${API_ENDPOINT_BASE_DOKAN}/reports`;
export const overViewAPI = `${API_DOMAIN_LOCAL}${API_ENDPOINT_BASE_DOKAN}/vendor-dashboard`;

// API Endpoints
export const reportSummeryAPI = `${reportsAPI}/summary`;
export const salesOverviewAPI = `${reportsAPI}/sales_overview`;
export const topEarnersAPI = `${reportsAPI}/top_earners`;
export const topSellingAPI = `${reportsAPI}/top_selling`;
export const ordersOverview = `${overViewAPI}/orders`;
export const productsOverview = `${overViewAPI}/products`;
export const profileOverview = `${overViewAPI}/profile`;
